import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/production-plans',
    name: 'POST_PRODUCTION_PLAN',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
